import { Component } from '@angular/core';

@Component({
  selector: 'app-wifi-icon',
  standalone: true,
  templateUrl: './wifi-icon.component.html',
})
export class WifiIconComponent {}
